import "./sub-partner.scss";
import {
  view,
  exports,
  filterSearch,
  back,
  fullScreen,
  openarrow,
  penwitharrow,
  createnote,
  redDelete,
  dataLoading,
  Download,
} from "../../assets/assets";
import httpApiCall from "../../service/api.service";
import toastr from "../elements/toast";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Table from "../elements/tableComponent";
import NoDataFound from "../NoDataFound/NoDataFound";
import * as XLSX from "xlsx";
import { countryWiseRegex, getLanguage, getStorageValue } from "../../service/shared.service";
import Dropdown from "react-bootstrap/Dropdown";
import { useEffect, useRef, useState } from "react";
import { CSVLink } from "react-csv";
import { Modal, Button, Spinner } from "react-bootstrap";
import { DateRangePicker } from "react-date-range";
import { formatDate } from "../../utils/DateFormat";
import NoDataRightScreen from "../NoDataRightScreen/NoDataRightScreen";
import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import CurrencyFormatter, { formatCurrencyUSA } from "../../utils/CurrencyFormatter";
import { Field, Formik } from "formik";
import Pagination from "../../utils/Pagination";

const SubPartner = () => {
  const toastrService = new toastr(true);
  const navigate = useNavigate();
  const [selectedTabs, setSelectedTabs] = useState();
  const [listData, setListData] = useState([]);
  const [listDataFilter, setListDataFilter] = useState();
  let [searchInput, setSearchInput] = useState("");
  const answer = useSelector((state: any) => state?.APIData?.partnerData);
  const [currencyLogo, setCurrencyLogo] = useState();
  const [colour, setColour] = useState(0);
  const [listView, setListView] = useState<any>(false);
  const [notesData, setNotesData] = useState<any>([]);
  const [offset, setOffset] = useState(Number);
  const [notesopen, setNotesOpen] = useState(false);
  const [textnotes, setTextNotes] = useState(false);
  const [tablevar, setTablevar] = useState(false);
  const [viaBlock, setViaBlock] = useState<boolean>(false);
  // const [goBack, setGoBack] = useState(false);
  const [textareaData, setTextareaData] = useState("");
  const [textareaData2, setTextareaData2] = useState({
    note: '',
    an_id: 0
  });
  const [shimmer, setShimmer] = useState(false);
  const [detailsShimmer, setDetailsShimmer] = useState(false);
  const [sppiner, setSppiner] = useState(false);
  let [searchParams, setSearchParams] = useSearchParams();
  const [selectedChoice, setSelectedChoice] = useState({
    label: "All",
    value: "0",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [exportCSVData, setexportCSVData] = useState({
    headers: [],
    data: [],
  });
  const [show, setShow] = useState(false);
  const [records, setRecords] = useState();
  const [visible, setVisible] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showBlockUnBlockAgentModal, setShowBlockUnBlockAgentModal] = useState(false);
  const [deleteAnId, setDeleteAnId] = useState(0);
  const [blockUnblockValue, setBlockUnblockValue] = useState(0);
  const [blockUnblockReasonValue, setBlockUnblockReasonValue] = useState('');
  const handleChoiceSelection = (item: any) => {
    setSelectedChoice(item);
    subPartnerList(item, false, "", false);
  };
  const [dateFilterData, setdateFilter] = useState<any>();
  const choices = [
    {
      value: 0,
      label: "All",
    },
    {
      value: 1,
      label: "Active",
    },
    {
      value: 2,
      label: "Inactive",
    },
  ];
  const columns = [
    {
      title: 'Sr.',
      dataKey: 'serialNumber'
    },
    {
      title: 'Sub Partner Name',
      dataKey: 'sunName'
    },
    {
      title: 'Email',
      dataKey: 'email'
    },
    {
      title: 'Sub Partner ID',
      dataKey: 'subId'
    },
    {
      title: 'Total Business Added',
      dataKey: 'buissnessAdded'
    },
    {
      title: 'Profit Earned	',
      dataKey: 'buiProfitEarnedssness'
    },
    {
      title: 'Expected Earning	',
      dataKey: 'expectedEarning	'
    },
    {
      title: 'Status',
      dataKey: 'status'
    }
  ];

  // to do
  if (!answer?.user_partner_info?.pu_id) {
    // columns.splice(columns.length - 1, 0, {
    //   title: 'Profit Earned',
    //   dataKey: 'profitEarned'
    // },
    //   {
    //     title: 'Expected Earning',
    //     dataKey: 'expectedEarning'
    //   })
    // console.log('columnscolumns', columns);
  }
  useEffect(() => {
    const data = (localStorage.getItem("gridView") + '') == '1' ? true : false;
    setListView(data)

    const getReferal = searchParams.get("referCode");
    if (getReferal) {
      searchInput = getReferal;
      setSearchInput(searchInput);
    }
    subPartnerList(0, false);
    if (answer) {
      const displayLogo =
        answer &&
        answer["country_currency_info"] &&
        answer["country_currency_info"]["currency"] &&
        answer["country_currency_info"]["currency"][0];
      const mobileCode =
        answer &&
        answer["country_currency_info"] &&
        answer["country_currency_info"]["country"];
      setCurrencyLogo(displayLogo);
      // setMobileCode(mobileCode);
    }
  }, [answer]);
  const exportType = {
    XLSX: "XLSX",
    CSV: "CSV",
  };
  let getProfile: any = getStorageValue("partnerProfile");
  if (getProfile && getProfile.length) {
    getProfile = getProfile[0];
  }
  const subPartnerList = async (
    filterData: any,
    exportFile: boolean = false,
    exportType: any = "",
    offset?: any,
    dataFilter: boolean = false
  ) => {
    setSelectedTabs(getProfile);

    const body = {
      access_token: getProfile.access_token,
      limit: exportFile ? 0 : 10,
      filter: filterData && filterData.value,
      search_string: searchInput,
      para_id: getProfile.para_id,
      partner_json: getProfile.partner_json,
      offset: offset ? offset : 0,
      referral_code: getProfile.referral_code,
      start_date: (dateFilterData && dateFilterData.startDate) || dataFilter ? formatDate(selectionRange.startDate) : "",
      end_date: (dateFilterData && dateFilterData.startDate) || dataFilter ? formatDate(selectionRange.endDate) : "",
      sort_order: "",
      time_offset: "",
      sort_by: "",
      language_preffered: getProfile.language_preffered,
      is_agent: 1,
    };
    setShimmer(true);
    setDetailsShimmer(true);
    await httpApiCall({ api: "getAgents_list", type: "post", body })
      .then((data) => {
        setShimmer(false);
        setDetailsShimmer(false);
        setRecords(data)
        setViaBlock(true);
        if (data && !data.is_error) {
          const listOfData = data.data;
          if (dataFilter && (!listOfData || listOfData.length == 0)) {
            setListDataFilter(undefined);
          }
          if (listOfData) {
            setListData(listOfData);
            if (dataFilter) {
              setdateFilter(selectionRange);
              // const valueOne = new Date(selectionRange.startDate)
              //   .toDateString()
              //   .slice(4);
              // const valueTwo = new Date(selectionRange.endDate)
              //   .toDateString()
              //   .slice(4);
              // setSearchInput(valueOne + " to " + valueTwo);
            }
            
            if (!exportType && (listOfData && listOfData.length > 0)) {
              getSubPartnerDetails(listOfData && listOfData[0] && listOfData[colour || 0 ]["agent_id"]);
            } else {
              setListDataFilter(undefined);
            }
          }
          if (exportFile) {
            exportCSV(exportType);
          }
        } else {
          // toastrService.showError(data.original_text || data.err);
        }
      })
      .catch((error) => {
        console.log("Error in Register:", error);
      });
  };


  const getFirstName = (firstName: any = "") => {
    //   let firstName = first + "-" + last;
    const split = `${firstName}`.split(" ");
    if (split.length > 1) {
      return String(split[0][0] + split[1][0]);
    } else if (Number(split.length) === 1) {
      return split[0][0].toUpperCase();
    }
  };
  const holdOn = (item: any, index: any) => {
    setViaBlock(false);
    getSubPartnerDetails(item.agent_id);
    setColour(index);
    if (!tablevar) {
      setListView(false);
      // setGridtolist(true)
    }
  };
  const deleteData = () => {
    if (searchParams.get("referCode")) {
      searchParams.delete("referCode");
      setSearchParams(searchParams);
    }
    searchInput = "";
    setSearchInput("");
    subPartnerList(0, false);
    setdateFilter({});
  };

  const showNotes = async () => {
    if (notesopen) {
      setNotesOpen(false);
      return;
    }
    const body = {
      access_token: selectedTabs && selectedTabs["access_token"],
      agent_id: listDataFilter && listDataFilter["agent_id"],
      partner_id: selectedTabs && selectedTabs["partner_id"],
    };
    await httpApiCall({ api: "get_notes", type: "post", body }).then(
      (data: any) => {
        if (data) {
          if (data && !data.is_error) {
            // console.log(data);
            setNotesData(data.notes);
            setNotesOpen(true);
            if (notesopen) {
              setTextNotes(false);
              // setNotesOpen(false);
              setTextareaData("");
            }
          } else {
            toastrService.showError(data.original_text || data.err);
          }
        } else {
          toastrService.showError("Something went wrong");
        }
      }
    );
  };

  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });
  const handleSelect = ({ selection }: any) => {
    setdateFilter(selection);
    setSelectionRange(selection);
    // console.log(selection);
  };

  const submitNotes = async () => {
    if (textareaData == textareaData2.note) {
      toastrService.showError("The current note must differ from the previous one.");
      return;
    }
    if (!textareaData) {
      toastrService.showError("Please enter note");
      return;
    }
    const body = {
      access_token: selectedTabs && selectedTabs["access_token"],
      agent_id: listDataFilter && listDataFilter["agent_id"],
      is_update: textareaData2.note ? 1 : 0,
      an_id: textareaData2.an_id ? textareaData2.an_id : undefined,
      note: textareaData,
      partner_id: selectedTabs && selectedTabs["partner_id"],
    };
    setSppiner(true);
    await httpApiCall({ api: "add_agent_note", type: "post", body })
      .then((data) => {
        setSppiner(false);
        if (data) {
          // console.log("successful");
          toastrService.showSuccess("Note saved sucessfully");
          showNotes();
          setTextareaData("");
          setTextareaData2({
            note: '',
            an_id: 0
          });
          setTextNotes(false);
        } else {
          toastrService.showError("Error while saving note");
        }
      })
      .catch((error) => {
        setSppiner(false);
        console.log("error");
      });
  };
  const checkLength = (event: any) => {
    const { value } = event.target;    
    const trimmedValue = value.trimStart();
    setTextareaData(trimmedValue);
  };

  const createNewNote = (note: any, id: any) => {
    setTextareaData(note);
    setTextareaData2({
      note: note,
      an_id: id
    });
    setTextNotes(true);
  };
  const deleteConfirm = async () => {
    setSppiner(true);
    const body = {
      access_token: selectedTabs && selectedTabs["access_token"],
      an_id: deleteAnId,
      partner_id: selectedTabs && selectedTabs["partner_id"],
    };
    await httpApiCall({ api: "delete_notes", type: "post", body })
      .then((data) => {
        setSppiner(false);
        setShowDeleteModal(false);
        if (data) {
          toastrService.showSuccess(data.msg);
          // console.log("successful");
          showNotes();
        } else {
          toastrService.showError("Error in notes");
          return;
        }
      })
      .catch((error) => {
        console.log("error");
      });
  };
  const handleChange = (event: any) => {
    if (event.target.value != 3) {
      setBlockUnblockReasonValue('');
    }
    setBlockUnblockValue(event.target.value)
  }
  // const tableData = (data: any) => {
  //    setListDataFilter(data);
  //    console.log(data);
  // };

  const exportCSV = (a: any) => {
    let list: any = [];
    let datalist: any = [];
    let headers: any = [];
    list[0] = {
      date_registered: getLanguage(
        "date_registered",
        selectedTabs && selectedTabs["language_preffered"]
      ),
      sub_partner_name: getLanguage(
        "Sub Partner Name",
        selectedTabs && selectedTabs["language_preffered"]
      ),
      email: getLanguage(
        "email",
        selectedTabs && selectedTabs["language_preffered"]
      ),
      total_number_of_contracts: getLanguage(
        "Total number of contracts",
        selectedTabs && selectedTabs["language_preffered"]
      ),
      added_by: getLanguage(
        "added_by",
        selectedTabs && selectedTabs["language_preffered"]
      ),
      stripe_account_id: getLanguage(
        "stripe_account_id",
        selectedTabs && selectedTabs["language_preffered"]
      ),
      sale_date: getLanguage(
        "sale_date",
        selectedTabs && selectedTabs["language_preffered"]
      ),
      note: getLanguage(
        "note",
        selectedTabs && selectedTabs["language_preffered"]
      ),
    };
    if (
      answer &&
      answer.partner_profile &&
      answer.partner_profile[0]["can_provide_doctor_share"]
    ) {
      list[0]["partner_share_from_doctor"] =
        "Share from " +
        getLanguage(
          "Business",
          selectedTabs && selectedTabs["language_preffered"]
        );
    }
    headers = Object.values(list[0]);
    let filter_doctors: any = listData;
    for (var i = 0; i < filter_doctors.length; i++) {
      list[i + 1] = {};

      list[i + 1].date_registered = new Date(
        `${filter_doctors[i]["date_registered"]}`
      ).toLocaleDateString();

      list[i + 1].sub_partner_name = filter_doctors[i]["agent_name"];

      list[i + 1].email = filter_doctors[i]["agent_email"];

      list[i + 1].total_number_of_contracts =
        filter_doctors[i]["total_financed_contract"] || 0;

      list[i + 1].added_by = filter_doctors[i]["added_by"] || 0;

      list[i + 1].stripe_account_id =
        filter_doctors[i]["stripe_account_id"] != null &&
          filter_doctors[i]["stripe_account_id"] != "null"
          ? getLanguage(
            "completed",
            selectedTabs && selectedTabs["language_preffered"]
          )
          : getLanguage(
            "pending",
            selectedTabs && selectedTabs["language_preffered"]
          );

      list[i + 1].sale_date =
        "First Contract Date" +
        (filter_doctors[i]["first_sale_on"]
          ? new Date(filter_doctors[i]["first_sale_on"]).toLocaleDateString()
          : "N/A") +
        " " +
        "Last Contract Date" +
        (filter_doctors[i]["last_sale_on"]
          ? new Date(filter_doctors[i]["last_sale_on"]).toLocaleDateString()
          : "N/A");

      list[i + 1].note = filter_doctors[i]["note"] || "-";

      datalist.push(Object.values(list[i + 1]));
    }
    if (a == exportType.CSV) {
      setexportCSVData({
        headers: headers,
        data: datalist,
      });
      setTimeout(() => {
        const link: any = document.getElementById("custom-hidden");
        link.setAttribute("download", "Sub-partner" + ".csv");
        link.click();
      }, 1000);
    }
    if (a == exportType.XLSX) {
      datalist.unshift(headers);
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.aoa_to_sheet(datalist);
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, "Sub-partner" + ".xlsx");
    }
  };
  const handlePageChange = (offset: number) => {
    // console.log(offset, "offset");
    let data = (offset - 1) * 10;
    subPartnerList(0, false, "", data);
  };

  // const handlePageChange = (page: any) => {

  //    setOffset(10)

  //    setCurrentPage(page);
  //    subPartnerList(0, false)

  // };

  // Render table rows for the current page
  // const renderRows = () => {
  //   return listData.slice(startIndex, endIndex).map((item, i) => (
  //     <tr
  //       key={i}
  //       onClick={() => {
  //         setTablevar(true);
  //         holdOn(item, i + startIndex);
  //       }}
  //     >
  //       <td>{i + startIndex + 1}</td>
  //     </tr>
  //   ));
  // };



  const rows = listData && listData.map((row: any, index: number) => {
    const singleRow = [
      index + 1,
      row.agent_name,
      row.agent_email,
      row.referral_code,
      row.total_sales_made || 0,
      formatCurrencyUSA(row?.total_earning || 0),
      // formatCurrencyUSA(listDataFilter && listDataFilter["total_earning"]? listDataFilter["total_earning"]: 0),
      // formatCurrencyUSA(listDataFilter &&listDataFilter["total_upcoming_earnings"]? listDataFilter["total_upcoming_earnings"]: 0),
      formatCurrencyUSA(row?.total_upcoming_earnings || 0),
      row.is_blocked == 1 ? "Blocked " : row.last_30_days_active,
     
    ]

    // to do
    if (!answer?.user_partner_info?.pu_id) {
      // singleRow.splice(singleRow.length - 1, 0,
      //   formatCurrencyUSA(row.total_earning || 0))
      // singleRow.splice(singleRow.length - 1, 0,
      //   formatCurrencyUSA(row.total_upcoming_earnings || 0))
    }
    return singleRow;
  });


  const downloadPDF = () => {
    const doc = new jsPDF();
    autoTable(doc, {
      headStyles: { fillColor: [1, 61, 80] },
      head: [columns.map((item) => item.title)],
      body: rows,
      styles: {
        fontSize: 9,
      },
    })

    doc.save('Sub Partner List.pdf');
  };

  const blockUnBlockAgent = async () => {
    if (listDataFilter && listDataFilter['is_blocked'] == 0) {
      if (!blockUnblockValue) {
        setShowBlockUnBlockAgentModal(true);
        toastrService.showError('Please select one of the reason to block sub partner');
        return;
      }
      if (blockUnblockValue == 3 && (!blockUnblockReasonValue || (blockUnblockReasonValue && !(blockUnblockReasonValue + '').trim().length))) {
        setShowBlockUnBlockAgentModal(true);
        toastrService.showError('Please enter reason to block sub partner');
        return;
      }
    }
    
    setSppiner(true);
    const body = {
      access_token: selectedTabs && selectedTabs["access_token"],
      agent_id: listDataFilter && listDataFilter['agent_id'],
      agent_level: listDataFilter && listDataFilter['agent_level'],
      block_unblock: listDataFilter && listDataFilter['is_blocked'] == 0 ? 1 : 0,
      blocked_reason: listDataFilter && listDataFilter['is_blocked'] == 0 && blockUnblockReasonValue ? blockUnblockReasonValue : undefined,
      is_blocked_type: listDataFilter && listDataFilter['is_blocked'] == 0 ? blockUnblockValue : undefined,
      parent_id: listDataFilter && listDataFilter['para_id'],
      partner_json: listDataFilter && listDataFilter["partner_json"],
      type: 2
    };
    await httpApiCall({ api: "block_unblock_agent", type: "post", body })
      .then((data) => {
        setViaBlock(true);
        setSppiner(false);
        if (data) {
          setShowBlockUnBlockAgentModal(false);
          subPartnerList(0, false);          
          toastrService.showSuccess(`Sub-Patner  ${blockUnblockValue ? 'Blocked': 'Unblock'} successfully`);
        } else {
          toastrService.showError("Something went wrong");
          return;
        }
      })
      .catch((error) => {
        console.log("error");
      });

      
  }


  const getSubPartnerDetails = async (agent_id: any) => {
    if (listDataFilter && listDataFilter['agent_id'] == agent_id && !viaBlock) {
      return;
    }
    const body = {
      access_token: getProfile.access_token,
      agent_id,
      is_agent: 1,
    };
    // setViaBlock(false);
    setDetailsShimmer(true);
    await httpApiCall({ api: "getAgents_details_v2", type: "post", body })
      .then((data) => {
        setDetailsShimmer(false);
        if (data && !data.is_error) {
          const detailsData = data.data;
          

          if (detailsData && detailsData.length) {
            if (detailsData[0] && detailsData[0].agent_phone) {
              detailsData[0].agent_phone = detailsData[0].agent_phone.replace(countryWiseRegex[answer["country_currency_info"]['country']['country_code']]['regex'], countryWiseRegex[answer["country_currency_info"]['country']['country_code']]['group'])
            }
            // console.log(countryWiseRegex)
            // if (detailsData[0] && detailsData[0].doctor_mobile) {
            //   detailsData[0].doctor_mobile = detailsData[0].doctor_mobile.replace(countryWiseRegex[answer["country_currency_info"]['country']['country_code']]['regex'], countryWiseRegex[answer["country_currency_info"]['country']['country_code']]['group'])
            // }
            setListDataFilter(detailsData[0]);

          }
        } else {
          // toastrService.showError(data.original_text || data.err);
        }
      })
      .catch((error) => {
        console.log("Error in Register:", error);
      });
  };

  const receiveData = async (index: any = {}) => {
    setTablevar(true);
    holdOn(listData[index], index);
  }

  return (
    <>
      {/* {shimmer ? (
        <div className="no_data_v2 text-center">
          <img src={dataLoading} alt="" />
        </div>
      ) : ( */}
        <div>
          {!listView && (
            <div className="sub-partner-main p-0">
              <div className="container-fluid position-relative">
                <div className="row">
                  <div
                    className={`${tablevar == true ? "d-none" : !visible ?  "col-lg-3 p-0" : "col-lg-3 d-none"}`}
                  >
                    <div className="left-wrapper">
                      {
                        shimmer ? (
                          <div className="no_data_v2 text-center">
                            <img src={dataLoading} alt="" />
                          </div>
                        ) : 
                        <div>

                          {/* header filter search part */}
                          <div className="left-header">
                            <div className="App">
                              <Dropdown>
                                <Dropdown.Toggle
                                  variant="Secondary"
                                  id="dropdown-basic"
                                >
                                  {selectedChoice.label}
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                  {choices.map((item, index) => (
                                    <Dropdown.Item
                                      key={index}
                                      onClick={() =>
                                        handleChoiceSelection(item)
                                      }
                                    >
                                      {item.label}
                                    </Dropdown.Item>
                                  ))}
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                            <div className="d-flex align-items-center">
                              <div className="list_view d-none d-lg-block">
                                <img
                                  className="me-3"
                                  src={view}
                                  alt=""
                                  onClick={() => {
                                    setListView(true);
                                    localStorage.setItem("gridView", '1')
                                  }}
                                />
                                <span></span>
                              </div>
                              <div>
                                <Dropdown>
                                  <Dropdown.Toggle
                                    variant="Secondary"
                                    id="dropdown-basic"
                                    disabled={listData && listData.length == 0}
                                  >
                                    <img src={exports} alt="" />
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu>
                                    <Dropdown.Item
                                      onClick={() =>
                                        subPartnerList(
                                          {},
                                          true,
                                          exportType.XLSX
                                        )
                                      }
                                    >
                                      XLSX
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() =>
                                        subPartnerList({}, true, exportType.CSV)
                                      }
                                    >
                                      CSV
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            </div>
                          </div>

                          <div className="search-bar">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search"
                              name="search"
                              value={searchInput}
                              onChange={(e) => setSearchInput(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  subPartnerList(0, false);
                                }
                              }}
                            />
                            {(searchInput || (dateFilterData && dateFilterData.startDate)) && (
                              <label
                                className="filter"
                                onClick={deleteData}
                              ></label>
                            )}
                            <div
                              onClick={() => setShow(true)}
                              className="date_range"
                            >
                              <img src={filterSearch} alt="" />
                            </div>
                          </div>

                          {/* header filter search part */}
                        </div>
                    }
                    {listData && !listData.length && (
                      <div className="nocompo">
                        <NoDataFound />
                      </div>
                    )}
                    <div
                      className={`${listData && listData.length ? "loop" : ""
                        }`}
                    >
                      {!shimmer && listData && listData.length
                        ? listData.map((item: any, index) => (
                          <div
                            className={`listing first_index ${index == colour ? "colour_chnage" : ""
                              }`}
                            key={index}
                            onClick={() => {
                              setTablevar(false);
                              holdOn(item, index);
                            }}
                          >
                            <div className="listing__left">
                              <h5>{item.agent_name}</h5>
                              <p>
                                Registered on{" "}
                                {`${new Date(
                                  item.date_registered
                                ).toLocaleDateString("en-US", {
                                  year: "numeric",
                                  month: "2-digit",
                                  day: "2-digit",
                                })}`}
                              </p>
                            </div>
                            <div className="listing__right">                            
                            {item['is_blocked'] == 0 && 
                              <p className={item.last_30_days_active}>{item.last_30_days_active}</p>
                            }
                              {item['is_blocked'] == 1 &&
                                <p className="blocked">
                                  Blocked
                                </p>
                              }
                              <div>
                                <p className="status-content d-lg-none" onClick={() => setVisible(true)} >
                                View Details
                            </p>
                                </div>
                            </div>
                          </div>
                        ))
                        : ""}

                      {records && records["number_of_records"] > 10 && (
                        <div className="-position-relative">
                          <Pagination
                            totalItems={records && records["number_of_records"]}
                            itemsPerPage={records && records["number_of_pages"]}
                            onPageChange={(offset: number) =>
                              handlePageChange(offset)
                            }
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div
                    className={`${
                      !tablevar && !visible ? `col-lg-9  d-none d-lg-block` : "col-12 grid_partner"
                    }`}
                >
                  {tablevar && (
                    <div
                      className="back-button"
                      onClick={() => {
                        setListView(true);
                        setTablevar(false);
                      }}
                    >
                      <img src={back} alt="" />
                      <span>Back</span>
                    </div>
                  )}




                  {/* details view */}
                  {detailsShimmer ? (
                    <div className="no_data_v2 text-center">
                      <img src={dataLoading} alt="" />
                    </div>
                  ) : (
                    !listData || (listData && !listData.length) ? (
                      <div className="nocompo">
                        <NoDataRightScreen />
                      </div>
                    ) :
                      listDataFilter && (
                        <div className="rightWrapper">
                          {visible}
                          <div className={"layout-wrapper__right "}  >
                          <span className="back-btn d-lg-none" onClick={() => setVisible(false)}></span>
                            <div className="main--wrapper">
                              <div className="main-wrap">
                                <div className="main--wrapper-profile" >
                                  <h1>{`${getFirstName(
                                    listDataFilter["agent_name"]
                                  )}`}</h1>
                                </div>

                                <div className="personal__info">
                                  <div className="name">
                                    <p>
                                      {listDataFilter["agent_name"]}


                                      {listDataFilter["last_30_days_active"] && listDataFilter['is_blocked'] == 0 && (
                                        <span className={listDataFilter &&
                                          listDataFilter["last_30_days_active"]}>
                                          {listDataFilter &&
                                            listDataFilter["last_30_days_active"]}
                                        </span>
                                      )}

                                      {listDataFilter['is_blocked'] == 1 &&
                                        <span className="blocked">
                                          Blocked
                                        </span>
                                      }

                                    </p>
                                    {/* <p className="register">
                                      Registered on{" "}
                                      {`${new Date(
                                        `${
                                          listDataFilter &&
                                          listDataFilter["date_registered"]
                                        }`
                                      ).toLocaleDateString("en-US", {
                                        year: "numeric",
                                        month: "2-digit",
                                        day: "2-digit",
                                      })}`}
                                    </p> */}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="business-wrapper--header">
                              {!answer?.user_partner_info?.pu_id && <div className="business-wrapper--left">
                                <p className="badge__info">
                                  <svg className="me-1" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.75 15.9198H13.4C14.05 15.9198 14.59 15.3398 14.59 14.6398C14.59 13.7698 14.28 13.5998 13.77 13.4198L12.76 13.0698V15.9198H12.75Z" fill="#007094"></path><path d="M11.9701 1.89992C6.45007 1.91992 1.98007 6.40992 2.00007 11.9299C2.02007 17.4499 6.51007 21.9199 12.0301 21.8999C17.5501 21.8799 22.0201 17.3899 22.0001 11.8699C21.9801 6.34992 17.4901 1.88992 11.9701 1.89992ZM14.2601 11.9999C15.0401 12.2699 16.0901 12.8499 16.0901 14.6399C16.0901 16.1799 14.8801 17.4199 13.4001 17.4199H12.7501V17.9999C12.7501 18.4099 12.4101 18.7499 12.0001 18.7499C11.5901 18.7499 11.2501 18.4099 11.2501 17.9999V17.4199H10.8901C9.25007 17.4199 7.92007 16.0399 7.92007 14.3399C7.92007 13.9299 8.26007 13.5899 8.67007 13.5899C9.08007 13.5899 9.42007 13.9299 9.42007 14.3399C9.42007 15.2099 10.0801 15.9199 10.8901 15.9199H11.2501V12.5399L9.74007 11.9999C8.96007 11.7299 7.91007 11.1499 7.91007 9.35992C7.91007 7.81992 9.12007 6.57992 10.6001 6.57992H11.2501V5.99992C11.2501 5.58992 11.5901 5.24992 12.0001 5.24992C12.4101 5.24992 12.7501 5.58992 12.7501 5.99992V6.57992H13.1101C14.7501 6.57992 16.0801 7.95992 16.0801 9.65992C16.0801 10.0699 15.7401 10.4099 15.3301 10.4099C14.9201 10.4099 14.5801 10.0699 14.5801 9.65992C14.5801 8.78992 13.9201 8.07992 13.1101 8.07992H12.7501V11.4599L14.2601 11.9999Z" fill="#007094"></path><path d="M9.42188 9.37008C9.42188 10.2401 9.73187 10.4101 10.2419 10.5901L11.2519 10.9401V8.08008H10.6019C9.95188 8.08008 9.42188 8.66008 9.42188 9.37008Z" fill="#007094"></path></svg>
                                  Total Network Commission Earned:
                                  <span className="color-green fs-14-contentwrap ms-1 notranslate">
                                    <CurrencyFormatter
                                      amount={
                                        listDataFilter && listDataFilter["total_profit_earned"]
                                          ? listDataFilter["total_profit_earned"]
                                          : 0
                                      }
                                    />
                                  </span>
                                </p>
                                <p className=" badge__info">
                                  <svg className="me-1" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.8086 6.24998H20.1686C19.9786 5.97998 19.7786 5.72998 19.5686 5.47998L18.8086 6.24998Z" fill="#F77600"></path><path d="M18.52 4.41982C18.27 4.20982 18.02 4.00982 17.75 3.81982V5.17982L18.52 4.41982Z" fill="#F77600"></path><path d="M19.5795 5.47994L22.5295 2.52994C22.8195 2.23994 22.8195 1.75994 22.5295 1.46994C22.2395 1.17994 21.7595 1.17994 21.4695 1.46994L18.5195 4.41994C18.8995 4.74994 19.2495 5.10994 19.5795 5.47994Z" fill="#F77600"></path><path d="M17.7517 3C17.7517 2.59 17.4117 2.25 17.0017 2.25C16.6017 2.25 16.2817 2.57 16.2617 2.96C16.7817 3.21 17.2817 3.49 17.7517 3.82V3Z" fill="#F77600"></path><path d="M21.7519 7C21.7519 6.59 21.4119 6.25 21.0019 6.25H20.1719C20.5019 6.72 20.7919 7.22 21.0319 7.74C21.4319 7.72 21.7519 7.4 21.7519 7Z" fill="#F77600"></path><path d="M12.75 14.7498H13.05C13.44 14.7498 13.75 14.3998 13.75 13.9698C13.75 13.4298 13.6 13.3498 13.26 13.2298L12.75 13.0498V14.7498Z" fill="#F77600"></path><path d="M21.04 7.74C21.03 7.74 21.02 7.75 21 7.75H17C16.9 7.75 16.81 7.73 16.71 7.69C16.53 7.61 16.38 7.47 16.3 7.28C16.27 7.19 16.25 7.1 16.25 7V3C16.25 2.99 16.26 2.98 16.26 2.96C14.96 2.35 13.52 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 10.48 21.65 9.04 21.04 7.74ZM13.75 11.82C14.39 12.04 15.25 12.51 15.25 13.98C15.25 15.23 14.26 16.26 13.05 16.26H12.75V16.51C12.75 16.92 12.41 17.26 12 17.26C11.59 17.26 11.25 16.92 11.25 16.51V16.26H11.17C9.84 16.26 8.75 15.14 8.75 13.76C8.75 13.34 9.09 13 9.5 13C9.91 13 10.25 13.34 10.25 13.75C10.25 14.3 10.66 14.75 11.17 14.75H11.25V12.53L10.25 12.18C9.61 11.96 8.75 11.49 8.75 10.02C8.75 8.77 9.74 7.74 10.95 7.74H11.25V7.5C11.25 7.09 11.59 6.75 12 6.75C12.41 6.75 12.75 7.09 12.75 7.5V7.75H12.83C14.16 7.75 15.25 8.87 15.25 10.25C15.25 10.66 14.91 11 14.5 11C14.09 11 13.75 10.66 13.75 10.25C13.75 9.7 13.34 9.25 12.83 9.25H12.75V11.47L13.75 11.82Z" fill="#F77600"></path><path d="M10.25 10.03C10.25 10.57 10.4 10.65 10.74 10.77L11.25 10.95V9.25H10.95C10.57 9.25 10.25 9.6 10.25 10.03Z" fill="#F77600"></path></svg>
                                  Network Commission Expected:
                                  <span className="color-blue fs-14-contentwrap ms-1 notranslate">
                                    <CurrencyFormatter
                                      amount={
                                        listDataFilter &&
                                          listDataFilter[
                                          "total_upcoming_earnings"
                                          ]
                                          ? listDataFilter[
                                          "total_upcoming_earnings"
                                          ]
                                          : 0
                                      }
                                    />
                                  </span>
                                </p>
                              </div>}
                            </div>

                            <div
                              className="accordion"
                              id="accordionPanelsStayOpenExample"
                            >
                              <div className="accordion-item mb-3">
                                <h2 className="accordion-header" id="headingOne">

                                  <button
                                    className="accordion-button pointerEventNone"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseOne"
                                    aria-expanded="true"
                                    aria-controls="collapseOne"
                                    id="Overview"
                                    
                                  >
                                  <div className="d-md-flex justify-content-between w-100 align-items-center">

                                    Sub Partner Overview

                                    {listDataFilter && !listDataFilter["stripe_account_id"] && 
                                    <div className="right--content-wrap --modify pe-md-3">
                                        <ul className="listing--inline ps-0 mt-md-0 mt-2" >
                                            <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <rect width="16" height="16" rx="8" fill="#F77600" fillOpacity="0.19"/>
                                                    <rect x="7" y="4" width="2" height="6" rx="1" fill="#F77600"/>
                                                    <rect x="7" y="11" width="2" height="2" rx="1" fill="#F77600"/>
                                                  </svg> <span className="font-normal"> Bank not added</span>
                                            </li>
                                            <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <rect width="16" height="16" rx="8" fill="#F77600" fillOpacity="0.19"/>
                                                    <rect x="7" y="4" width="2" height="6" rx="1" fill="#F77600"/>
                                                    <rect x="7" y="11" width="2" height="2" rx="1" fill="#F77600"/>
                                                  </svg> <span className="font-normal"> Profile information missing</span>
                                            </li>
                                        </ul>
                                    </div>
                                    }
                                  </div>
                                  </button>
                                </h2>
                                <div
                                  id="collapseOne"
                                  className="accordion-collapse collapse show"
                                  aria-labelledby="headingOne"
                                  data-bs-parent="#accordionExample"
                                >
                                  <div className="accordion-body">
                                    <div className="row">
                                      <div className="col-md-4 col-sm-6">
                                        <h5 className="mb-0 sub-head">
                                          Total Businesses Added:
                                        </h5>
                                        <p className="mb-0 sub-para">
                                          {listDataFilter &&
                                            listDataFilter["total_business_added"]
                                            ? listDataFilter[
                                            "total_business_added"
                                            ]
                                            : 0}
                                        </p>
                                      </div>
                                      <div className="col-md-4 col-sm-6">
                                        <h5 className="mb-0 sub-head">
                                          Total Sub Partner Added:
                                        </h5>
                                        <p className="mb-0 sub-para">
                                          {listDataFilter &&
                                            listDataFilter["total_agents"]
                                            ? listDataFilter["total_agents"]
                                            : 0}
                                        </p>
                                      </div>
                                      <div className="col-md-4 col-sm-6">
                                        <h5 className="mb-0 sub-head">
                                          Registration Date:
                                        </h5>
                                        <p className="mb-0 sub-para">
                                          {" "}
                                          {`${new Date(
                                            `${listDataFilter &&
                                            listDataFilter["date_registered"]
                                            }`
                                          ).toLocaleDateString("en-US", {
                                            year: "numeric",
                                            month: "2-digit",
                                            day: "2-digit",
                                          })}`}
                                        </p>
                                      </div>

                                      <div className="col-md-4 col-sm-6">
                                        <h5 className="mb-0 sub-head">Email:</h5>
                                        <p className="mb-0 sub-para">
                                          {listDataFilter["agent_email"] || "N.A"}
                                        </p>
                                      </div>

                                      <div className="col-md-4 col-sm-6">
                                        <h5 className="mb-0 sub-head">Phone</h5>
                                        <p className="mb-0 sub-para">
                                          {(listDataFilter["agent_phone_country_code"] ? listDataFilter["agent_phone_country_code"] : '') + " " + listDataFilter["agent_phone"] || "N.A"}
                                        </p>
                                      </div>

                                      <div className="col-md-4 col-sm-6">
                                        <h5 className="mb-0 sub-head">
                                          First sale on:
                                        </h5>
                                        <p className="mb-0 sub-para">
                                          {(listDataFilter["first_sale_at"] &&
                                            `${new Date(
                                              `${listDataFilter &&
                                              listDataFilter["first_sale_at"]
                                              }`
                                            ).toLocaleDateString("en-US", {
                                              year: "numeric",
                                              month: "2-digit",
                                              day: "2-digit",
                                            })}`) ||
                                            "N.A"}
                                        </p>
                                      </div>

                                      <div className="col-md-4 col-sm-6">
                                        <h5 className="mb-0 sub-head">
                                          Last sale on:
                                        </h5>
                                        <p className="mb-0 sub-para">
                                          {(listDataFilter["last_sale_at"] &&
                                            `${new Date(
                                              `${listDataFilter &&
                                              listDataFilter["last_sale_at"]
                                              }`
                                            ).toLocaleDateString("en-US", {
                                              year: "numeric",
                                              month: "2-digit",
                                              day: "2-digit",
                                            })}`) ||
                                            "N.A"}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="pt-2">
                                <button id="setBlock" className="block-btn" onClick={() => {
                                  setShowBlockUnBlockAgentModal(true)
                                  setBlockUnblockValue(0);
                                  setViaBlock(true);
                                }} >{listDataFilter['is_blocked'] == 0 ? 'Block' : 'Unblock'} Sub Partner</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                  }

                  {/* details view */}


                  {/* Notes section */}
                  {(tablevar || !listView) && listData && listData.length > 0 && (
                    <div
                      className={`partner_notes ${notesopen ? "transformNote-main" : ""
                        }`}
                    >
                      <p
                        onClick={showNotes}
                        className={`partner_notes_open ${!answer?.user_partner_info?.pu_id ? '' : "top-120"} ${notesopen ? "transformNote" : ""
                          }`}
                      >
                        <span
                          className={`arrow ${notesopen ? "closearrow" : ""}`}
                        >
                          <img src={openarrow} alt="" />
                        </span>
                        <span className="notes-content">
                          <img src={penwitharrow} alt="" />
                          <span>Notes</span>
                        </span>
                      </p>
                      {notesopen && (
                        <div className="partner_notes_started">
                          <div className="noteheader">
                            <div className="noteheader_one">
                            <div className="notes_cross d-sm-none " onClick={showNotes}>
                           <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
                          </svg></div>
                              <p> Notes</p>
                              <p>
                                You can add/update notes for your agent.{" "}
                              </p>
                            </div>

                            <div className="noteheader-input">
                              <div>
                                {textnotes ? (
                                  <div>
                                    <div className="create-note-inputform">
                                      <textarea
                                        className="w-100"
                                        placeholder="Description"
                                        rows={5}
                                        onChange={checkLength}
                                        value={textareaData}
                                      ></textarea>
                                    </div>
                                    <div className="btn--group">
                                      <button
                                        className="save"
                                        onClick={() => submitNotes()}
                                        disabled={sppiner}
                                        id="submitNotes"
                                      >
                                        <span className="mr-3">Save</span>
                                        {sppiner && (
                                          <Spinner
                                            as="span"
                                            className="ml-2"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                          />
                                        )}
                                      </button>
                                      <button
                                      id="cancel-subPartner-Notes"
                                        className="cancel"
                                        onClick={() => {
                                          setTextNotes(false);
                                          setTextareaData("");
                                        }}
                                      >
                                        Cancel
                                      </button>
                                    </div>
                                  </div>
                                ) : (
                                  <div>
                                    <button
                                      className="button-font create-btn"
                                      onClick={() => setTextNotes(true)}
                                      id="create-sub-partnerNotes"
                                    >
                                      + Create New Note
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="notes-modal--body">
                            {notesData && notesData.length > 0
                              ? notesData.map((item:any, index:any) => (
                                <div className="notes-modal--body-card">
                                  <div className="card-header">
                                    <div className="card-header-content">
                                      <p className="fs-14-contentwrap">
                                        {item && item["note"]}
                                      </p>
                                    </div>
                                    { item && item["auto_generated"] == 0 &&  
                                    <div className="card-header-images">
                                      <span
                                        onClick={() =>
                                          createNewNote(
                                            item["note"],
                                            item["an_id"]
                                          )
                                        }
                                      >
                                        <img src={createnote} alt="" />
                                      </span>
                                      <span
                                        onClick={() => {
                                          setShowDeleteModal(true);
                                          setDeleteAnId(item["an_id"])
                                        }
                                        }
                                      >
                                        <img src={redDelete} alt="" />
                                      </span>
                                    </div>}
                                   
                                  </div>
                                  <div className="card-footer">
                                    <span className="date fs-12-mini-paragraph notranslate">
                                      {`${item && item["date_added"]
                                          ? new Date(
                                            item["date_added"]
                                          ).toLocaleDateString("en-US", {
                                            year: "numeric",
                                            month: "2-digit",
                                            day: "2-digit",
                                          })
                                          : ""
                                        }`}
                                    </span>
                                    <span className="time fs-12-mini-paragraph notranslate">
                                      {`${item && item["date_added"]
                                          ? new Date(
                                            item["date_added"]
                                          ).toLocaleTimeString([], {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                          })
                                          : ""
                                        }`}
                                    </span>
                                  </div>
                                </div>
                              ))
                              : ""}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {/* Notes section */}


                  <div
                    className="add_sub_partner d-none d-lg-block"
                    onClick={() => navigate("/app/new-sub-partner")}>
                    {" "}
                    <button id="add-new-sub-partner"> + Add New Sub Partner </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}


        {listView && (
          <div className="table_partner">
            <div className="sub-partner-main">
              <div className="left-wrapper table_data">

                {/* header filter search part listview */}

                <div className="left-header">
                  <div className="App">
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="Secondary"
                        id="dropdown-basic"
                      >
                        {selectedChoice.label}
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        {choices.map((item, index) => (
                          <Dropdown.Item
                            key={index}
                            onClick={() => handleChoiceSelection(item)}
                          >
                            {item.label}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div className="mx-3 d-flex align-items-center">
                    <div className="grid_view">
                      <img
                        src={fullScreen}
                        alt=""
                        onClick={() => {
                          setTablevar(false);
                          setListView(false);
                          localStorage.setItem("gridView", '0')
                        }}
                      />
                    </div>
                    <div>
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="Secondary"
                          id="dropdown-basic"
                          disabled={listData && listData.length == 0}
                        >
                          <img src={exports} alt="" />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() =>
                              subPartnerList({}, true, exportType.XLSX)
                            }
                          >
                            XLSX
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() =>
                              subPartnerList({}, true, exportType.CSV)
                            }
                          >
                            CSV
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    {/* <div className="cursor" onClick={downloadPDF}>
                              <img src={Download} alt="" />
                              <span className="ms-2">Pdf</span>
                            </div> */}
                  </div>
                </div>

                <div className="d-flex align-items-center gap-2">
                  <div className="search-bar grid_search search-bar-v2">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search"
                      name="search"
                      value={searchInput}
                      onChange={(e) => setSearchInput(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          subPartnerList(0, false);
                        }
                      }}
                      disabled={listData && listData.length == 0}
                    />

                    {(searchInput || (dateFilterData && dateFilterData.startDate)) && (
                      <label className="filter" onClick={deleteData}></label>
                    )}
                    <div onClick={() => setShow(true)} className="date_range">
                      <img src={filterSearch} alt="" />
                    </div>
                  </div>

                  <div className="" onClick={() => navigate("/app/new-sub-partner")}>
                    <button id="new-sub-partner"> + Add New Sub Partner </button>
                  </div>
                </div>

                {/* header filter search part listview */}
              </div>
            </div>
            {shimmer ? (
              <div className="no_data_v2 text-center">
                <img src={dataLoading} alt="" />
              </div>
            ) : (listData && listData.length > 0 ? (
              <Table id="sub-table" callFunction={(index: any) => receiveData(index)} data={rows} columns={columns}></Table>
            ) : (
              <NoDataRightScreen />
            ))}
            {records && records["number_of_records"] > 10 && (
              <div>
                <Pagination
                  totalItems={records && records["number_of_records"]}
                  itemsPerPage={records && records["number_of_pages"]}
                  onPageChange={(offset: number) =>
                    handlePageChange(offset)
                  }
                />
              </div>
            )}
          </div>
        )}


      </div>
      {/* )} */}
      {exportCSVData.data && exportCSVData.data.length != 0 && (
        <CSVLink
          data={exportCSVData.data}
          headers={exportCSVData.headers}
          filename={"data.csv"}
          id="custom-hidden"
        />
      )}

      <div
        className="modal show"
        style={{ display: "block", position: "initial" }}
      >
        {show && (
          <Modal
            show={show}
            onHide={() => setShow(false)}
            className="date_modal"
          >
            <Modal.Header closeButton>
              <Modal.Title>Date Range</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {" "}
              <div>
                <DateRangePicker
                  ranges={[selectionRange]}
                  onChange={handleSelect}
                  inputRanges={[]}
                  showMonthArrow={true}
                  showMonthAndYearPickers={true}
                  maxDate={new Date()}
                // showDateDisplay={false}
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button id="close-sub" className="" onClick={() => setShow(false)}>
                Close
              </Button>
              <Button
                onClick={() => {
                  setShow(false);
                  subPartnerList(0, false, "");
                }}
              >
                Save Changes
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </div>

      {showDeleteModal && (
        <Modal
          show={showDeleteModal}
          onHide={() => setShowDeleteModal(false)}
          className="delete_date_modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>Delete Note</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              Are you sure you want to delete this note ?
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button id="delete-sub" className="" onClick={() => {
              setShowDeleteModal(false)
              setDeleteAnId(0);
            }}>
              Cancel
            </Button>
            <Button
            id="confirmDelete"
              style={{ 'border': 'solid 1px' }}
              disabled={sppiner}
              onClick={() => {
                // setShowDeleteModal(false);
                deleteConfirm();
                // subage(0, false, false, 0, true);
              }}
            >
              <span className="">Delete</span>
              {sppiner && (
                <Spinner
                  style={{ 'marginLeft': '5px' }}
                  as="span"
                  className="ml-2"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {showBlockUnBlockAgentModal && (
        <Modal
          show={showBlockUnBlockAgentModal}
          onHide={() => setShowBlockUnBlockAgentModal(false)}
          className="delete_date_modal" centered
        >
          <Modal.Header closeButton>
            <Modal.Title> { listDataFilter && listDataFilter['is_blocked'] == 1 ? " Unblock": 'Block' } Sub-Partner</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {listDataFilter && listDataFilter['is_blocked'] == 0 && <div>
              <p>Choose reason to {listDataFilter && listDataFilter['is_blocked'] == 0 ? 'Block' : 'Unblock'} this Sub-Partner?</p>
              <div>
                <div className="row priorty" onChange={handleChange}>
                  <div style={{ 'padding': '5px 20px' }} className="col-lg-12 label_inputs">
                    <input className="mr-3 opacity" type="radio" name="is_blocked_type" id="blockagent1" value="1" />
                    <label className="cursor" htmlFor="blockagent1" >Not Active</label>
                  </div>
                  <div style={{ 'padding': '5px 20px' }} className="col-lg-12 label_inputs">
                    <input className="mr-3 opacity" type="radio" name="is_blocked_type" id="blockagent2" value="2" />
                    <label className="cursor" htmlFor="blockagent2">Fraudulent</label>
                  </div>
                  <div style={{ 'padding': '5px 20px' }} className="col-lg-12 label_inputs">
                    <input className="mr-3 opacity" type="radio" name="is_blocked_type" id="blockagent3" value="3" />
                    <label className="cursor" htmlFor="blockagent3">Other</label>
                  </div>
                </div>
                {blockUnblockValue == 3 && <div>
                  <textarea
                    rows={3}
                    style={{ 'resize': 'none' }}
                    placeholder={'Please describe reason'}
                    className="form-control mt-3"
                    onChange={(event: any) => setBlockUnblockReasonValue(event.target.value)}
                  />
                </div>}
              </div>
            </div>}
            {
              listDataFilter && listDataFilter['is_blocked'] == 1 &&
              <div>
                Are you sure you want to unblock sub partner?
              </div>
            }
          </Modal.Body>
          <Modal.Footer>
            <Button id="unblockAgent" className="" onClick={() => {
              setShowBlockUnBlockAgentModal(false)
            }}>
              Cancel
            </Button>
            <Button
              // style={{'border': 'solid 1px'}}
              disabled={sppiner}
              onClick={() => {
                // setShowDeleteModal(false);
                blockUnBlockAgent();
                // subage(0, false, false, 0, true);
              }}
            >
              <span className="">Confirm</span>
              {sppiner && (
                <Spinner
                  as="span"
                  style={{ 'marginLeft': '5px' }}
                  className="ml-2"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      )}

    </>
  );
};

export default SubPartner;
